import errorReporter from '@app/errorReporter';

angular.module('bb.appointments').component('bbAppointmentPreviewButton', {
  transclude: true,
  bindings: {
    listingId: '<',
    appointmentId: '@?',
  },
  controller: AppointmentPreviewButtonController,
  controllerAs: 'vm',
  template: require('./appointment_preview_button.html'),
});

AppointmentPreviewButtonController.$inject = ['ModalService', '$route'];
function AppointmentPreviewButtonController(ModalService, $route) {
  const vm = this;
  vm.$onInit = function () {
    if (!vm.appointmentId) {
      return errorReporter.error('you must provide an appointmentId');
    }
  };

  // onClick function to open modal
  vm.openPreview = function () {
    ModalService.openAppointmentModal(vm.appointmentId, vm.listingId).then(
      function (updated) {
        if (updated) $route.reload();
      },
    );
  };
}
